import { DateTime } from 'luxon'
import Vue from 'vue'

export function toLocaleDateString(dateString) {
  const date = DateTime.fromISO(dateString).setLocale('de-CH')
  if (date.isValid) {
    return date.toLocaleString()
  }
  return dateString
}
Vue.filter('toLocaleDateString', toLocaleDateString)

export function toLocaleDateTimeString(dateTimeString) {
  const date = DateTime.fromISO(dateTimeString).setLocale('de-CH')
  if (date.isValid) {
    return date.toLocaleString(DateTime.DATETIME_MED)
  }
  return dateTimeString
}
Vue.filter('toLocaleDateTimeString', toLocaleDateTimeString)

// Filter to get the day
export function toLocaleDay(dateString) {
  const date = DateTime.fromISO(dateString).setLocale('de-CH')
  return date.isValid ? date.day : null
}
Vue.filter('toLocaleDay', toLocaleDay)

// Filter to get the month
export function toLocaleMonth(dateString) {
  const date = DateTime.fromISO(dateString).setLocale('de-CH')
  return date.isValid ? date.toFormat('MMMM') : null
}
Vue.filter('toLocaleMonth', toLocaleMonth)

// Filter to get the year
export function toLocaleYear(dateString) {
  const date = DateTime.fromISO(dateString).setLocale('de-CH')
  return date.isValid ? date.year : null
}
Vue.filter('toLocaleYear', toLocaleYear)
